import * as React from "react";
import { observer } from "mobx-react-lite";
import { Form, Input, Modal, notification } from "antd";
import { trimRequired } from "src/common/validationRules/trimRequired";
import { onError } from "src/common/onError";
import { bom2aStore as store } from "../Bom2aStore";

export const Bom2aCreateModal: React.FC = observer(() => {
  const [form] = Form.useForm();
  const isOpen = store.mode === "create";
  React.useEffect(() => {
    form.resetFields();
  }, [isOpen]);
  const onSuccess = async () => {
    notification.success({ message: "Создание выполнено успешно" });
    await store.reload();
  };
  return (
    <Modal
      open={isOpen}
      onCancel={() => store.setMode(null)}
      title="Новый экземпляр объекта BOM"
      modalRender={(content) => (
        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => {
            store.doCreate(values).then(onSuccess).catch(onError);
          }}
          disabled={store.buzy}
        >
          {content}
        </Form>
      )}
      okText="Создать"
      okButtonProps={{ htmlType: "submit", loading: store.buzy }}
    >
      <Form.Item name="name" label="Название" rules={[trimRequired()]}>
        <Input allowClear />
      </Form.Item>
    </Modal>
  );
});
